// Small words for order cards (My Orders).

/** What the customer paid: food + delivery (not for pickup) + tip + tax + service fee. */
export const orderTotal = (o) =>
  parseFloat(o.orderAmount || 0) +
  (o.isPickedUp ? 0 : parseFloat(o.deliveryCharges || 0)) +
  parseFloat(o.tipping || 0) +
  parseFloat(o.taxationAmount || 0) +
  parseFloat(o.serviceFee || 0);

// Abbreviations that stay in capitals inside a title-cased name.
const KEEP_CAPS = new Set(["USA", "BBQ", "BLT", "NY", "NYC", "XL", "XXL", "BOGO", "PB&J", "TV"]);

/** "PROSCIUTTO DI PARMA, USA" → "Prosciutto Di Parma, USA"; anything not all capitals stays as written. */
export function titleCaseIfShouting(text) {
  const s = String(text || "");
  const letters = s.replace(/[^A-Za-z]/g, "");
  if (letters.length < 2 || letters !== letters.toUpperCase()) return s;
  return s.replace(/[A-Za-z][A-Za-z&'.]*/g, (word) =>
    KEEP_CAPS.has(word.toUpperCase()) ? word.toUpperCase() : word.charAt(0) + word.slice(1).toLowerCase()
  );
}

/** The size or first option worth showing beside an item ("Small", "For 2"); null for a plain default. */
export function itemOption(item) {
  const v = String(item?.variation?.title || "").trim();
  if (v && !/^default$/i.test(v) && v.toLowerCase() !== String(item?.title || "").trim().toLowerCase()) return titleCaseIfShouting(v);
  const first = (item?.addons || []).flatMap((a) => a.options || []).find((o) => o?.title);
  return first ? titleCaseIfShouting(first.title) : null;
}
